import { ChevronLeft, X } from 'lucide-react';
import { SheetHeader, SheetTitle } from '@/components/atoms/sheet';

interface DataTableDrawerHeaderProps {
  title: string;
  onClose: () => void;
  onBack?: () => void;
  onReset?: () => void;
  resetDisabled?: boolean;
}

export function DataTableDrawerHeader({
  title,
  onClose,
  onBack,
  onReset,
  resetDisabled = false,
}: DataTableDrawerHeaderProps) {
  return (
    <SheetHeader className="border-b px-5 py-4">
      <div className="flex items-center justify-between">
        <div className="flex min-w-0 items-center gap-1">
          {onBack ? (
            <button
              onClick={onBack}
              className="mr-1 shrink-0 text-muted-foreground hover:text-foreground"
              aria-label="Back"
            >
              <ChevronLeft size={16} />
            </button>
          ) : null}
          <SheetTitle className="text-sm font-semibold">{title}</SheetTitle>
        </div>
        <div className="flex items-center gap-3">
          {onReset ? (
            <button
              onClick={onReset}
              disabled={resetDisabled}
              className="text-xs text-muted-foreground underline underline-offset-2 hover:text-foreground disabled:cursor-default disabled:no-underline disabled:opacity-40"
            >
              Reset
            </button>
          ) : null}
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
            <X size={16} />
          </button>
        </div>
      </div>
    </SheetHeader>
  );
}
